import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ReloadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g clipPath="url(#reload-clip)">
      <path
        d="M20 7H13L16.2412 3.75781C15.156 2.67194 13.6568 2 12 2C8.68629 2 6 4.68629 6 8C6 11.3137 8.68629 14 12 14C14.2205 14 16.1578 12.7929 17.1953 11H19.416C18.229 13.9314 15.357 16 12 16C7.58172 16 4 12.4183 4 8C4 3.58172 7.58172 0 12 0C14.2092 0 16.2072 0.896849 17.6543 2.34473L20 0V7Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="reload-clip">
        <rect width="16" height="16" fill="white" transform="translate(4)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SwapIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g clipPath="url(#swap-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 4V14H16V16H4V4H6ZM20 12H8V0H20V12ZM18 10V2H10V10H18Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="swap-clip">
        <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 -1 20 16)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const SplitIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M20 16H4V0H20V16ZM13 14H18V2H13V14ZM6 14H11V2H6V14Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const CollapseIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 15.0711L17.6569 9.41421L16.2426 8L12 12.2426L7.75736 8L6.34315 9.41421L12 15.0711Z"
      fill="currentColor"
    />
  </SvgIcon>
);
